module.exports = __webpack_public_path__ + "img/u119.e10da95b.svg";